const interactiveExperienceServiceUrl = "https://interactive-experience.dev-creator-tools.siriusxm.com";

export const environment = {
    interactiveExperienceServiceUrl,
    cognito: {
        userPoolId: "us-east-2_Fj0exhioR",
        userPoolClientId: "kt6j1q9atnb5ttlrg91oku1lf",
        oauthDomain: "app-crt-tools-interactive-experience-service-dev-auth.auth.us-east-2.amazoncognito.com",
        redirectSignIn: "https://interactive-experience-ui.dev-creator-tools.siriusxm.com/auth/callback",
        redirectSignOut: "https://interactive-experience-ui.dev-creator-tools.siriusxm.com/"
    }
};
